import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';
import Constant from './../common/Constant';

const DEFAULT_STATE = Immutable({
  uid: '',
  email: '',
  displayName: '',
  settings: {
    alertIncrementMinutes: Constant.DEFAULT_ALERT_INCREMENT_MINUTES,
    alertInterval: Constant.ALERT_INTERVAL_HOURLY,
    alertDays: Constant.DEFAULT_ALERT_DAYS,
    alertStartingAt: Constant.DEFAULT_ALERT_STARTING_AT,
    alertEndingAt: Constant.DEFAULT_ALERT_ENDING_AT,
    alertEnabled: Constant.DEFAULT_ALERT_ENABLED,
    alertPausedDate: Constant.DEFAULT_ALERT_PAUSED_DATE,
    defaultCurrency: Constant.DEFAULT_CURRENCY_CODE,
  },
  activity: {
    lastActiveProjects: [],
  },
  timer: {
    status: Constant.TIMER_NOT_RUNNING,
    projectId: '',
    startAtMillis: 0,
    millisRecorded: 0,
  },
  migration: 0,
});

export default function(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case ActionTypes.USER_LOGGED_IN:
    case ActionTypes.USER_SETTINGS_UPDATED:
      return state.merge(action.user);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js